function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBanRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.334 23.73L8.27 9.666c.418-.51.885-.979 1.396-1.397L23.73 22.334a9.956 9.956 0 01-1.396 1.396zM16 2C8.268 2 2 8.267 2 16c0 7.732 6.268 14 14 14s14-6.268 14-14c0-7.733-6.268-14-14-14z",
    fill: props.color
  }));
}

export default SvgIconBanRexFilled;